import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Whale in the sky",
  "description": "",
  "published": "2007-03-25T00:00:00.000Z",
  "redirect_from": ["/blog/whale-in-the-sky/swizec/255"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few days ago`}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Airbus_A380"
      }}>{` the new whale of the skies`}</a>{` has apparently been taken for a test drive with some press people and businessmen in its bowels. They created a nice `}<a parentName="p" {...{
        "href": "http://www.popularmechanics.com/blogs/science_news/4213543.html"
      }}>{`news post`}</a>{` about it accompanied by a rather impressive video of what went on.`}</p>
    <p>{`The biggest concern surrounding the Airbus A380 right now seems to be its sheer size and massivenes, which is apparently the reason for why it hasn't realyl been bought by almost anyone. It is said that terminals would have to be modified a lot and runways made stronger and that it simply does not fit today's world and is rather too large. Hold on, too large to be useful? Isn't that the same thing that was said of the Boeing 747 all those years ago, think it was 40, and isn't that right now the single most commercially succesful whale of the skies? Just give the poor sappling some time people, it'll catch on, you'll see.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      